import React, { useState } from 'react'
import PurchasePlan from '../Helpers/Modal/Plans/PurchasePlan'
import AdditionalProfilesModal from '../Helpers/Modal/Plans/AdditionalProfilesModal'
import { HTTP } from '../../api/resources'
import AddOnPurchase from '../Helpers/Modal/Plans/AddOnPurchase'

export default function ({plan, end_date, total_profiles, start_date, receipts, user, team}) {
  const [openPlansModal, setOpenPlansModal] = useState(false)
  const [showItems, setShowItems] = useState(false)
  const [openProfilesModal, setOpenProfilesModal] = useState(false)
  const [buyingProfiles, setBuyingProfiles] = useState(false)
  const [activating, setActivating] = useState(false)
  const [showAddOn, setShowAddOn] = useState(false)
  const [saving, setSaving] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [showBreakdown, setShowBreakdown] = useState(false)

  const handleBuyProfiles = async (value) => {
    setBuyingProfiles(true)

    try {
      await profilesRequest(value)
      setBuyingProfiles(false)
      setOpenProfilesModal(false)
      Alert.show('notice', `Purchased ${value} additional profiles successfully`)
      setTimeout(() => window.location.reload(), 1500)
    } catch {
      Alert.show('error', 'Failed to purchase profiles, try again')
      setBuyingProfiles(false)
    }
  }

  const profilesRequest = (value) => {
    return HTTP.post('/team/plan/profiles', {profiles: value})
  }

  const plansRequest = () => {
    return HTTP.post('/team/plan/activate')
  }

  const showAdditionalProfiles = () => {
    if (plan.name == 'Enterprise' && plan.active) return true
    if (plan.next_billing && plan.next_billing.name == 'Enterprise') return true
    return false
  }

  const showUpgradePlan = () => {
    if (plan.name == 'Enterprise' && plan.active) return false
    if (plan.next_billing && plan.next_billing.name == 'Enterprise') return false 
    return true
  }

  const purchaseDomain = async () => {
    setSaving(true)
    try {
      let response = await domainPurchaseRequest()
      window.location = response.data
    } catch {
      Alert.show('error', 'Could not connect to Stripe')
      setSaving(false)
    }
  }

  const domainPurchaseRequest = () => {
    return HTTP.post('/team/plan/add_ons', 'Purchase custom domain')
  }

  const costTitle = () => {
    if (plan.name === 'Grassroot') {
      return team.use_custom_pricing ? `$${team.grassroot_plan} for plan` : '$30 for plan';
    }
  
    if (plan.name === 'Enterprise' && plan.profile_limit === 200) {
      return team.use_custom_pricing ? `$${team.enterprise_plan} for plan` : '$30 for plan';
    }
  
    if (plan.name === 'Enterprise' && plan.profile_limit > 200) {
      const plan_info = team.use_custom_pricing ? `$${team.enterprise_plan} for plan` : '$30 for plan';
      const pricingInfo1 = ` $${team.profile_cost * ((plan.profile_limit - 200) / 100)} for profiles`;
      const pricingInfo2 = ` $${5 * ((plan.profile_limit - 200) / 100)} for profiles`;
      const pricingInfo = team.use_custom_pricing ? pricingInfo1 : pricingInfo2;
      return plan_info + pricingInfo;
    }
  
    return 'Plan is free';
  };
  

  return (
    <div>
        {/* Plan information */}
        <div className='card'>
            <div className='card-header d-flex align-items-center justify-content-between'>
                <h4 className='card-title'>Plan Information</h4>
                {user.user_type == 'manager' && 
                  <div>
                    {showUpgradePlan() && team.plans_activated &&
                      <button className='btn btn-primary mr-1' onClick={() => setOpenPlansModal(true)}>
                        Upgrade Plan
                      </button>
                    }
                    {showAdditionalProfiles() && team.plans_activated &&
                      <button className='btn btn-primary mr-1' onClick={() => setOpenProfilesModal(true)}>
                        Buy Additional Profiles
                      </button>
                    }

                    {!team.purchased_custom_domain && (plan.name == 'Grassroot' || plan.name == 'Enterprise' || plan.name == 'Free Trial') &&
                      <button className='btn btn-primary mr-1' onClick={() => setOpenModal(true)}>
                        Purchase Add Ons
                      </button>
                    }
                  </div>
                }
            </div>

            <div className='card-body'>
              <div className='row'>
                <div className='col-md-6'>
                  <p><b>Plan Name: </b> {plan.name}</p>
                </div>
                <div className='col-md-6'>
                  <p>
                    <b>Cost (USD): </b> 
                    { !showBreakdown && <>{plan.cost ? `$${plan.cost} ` : 'Free '}</>}
                    { showBreakdown && <> { costTitle() } </>}
                    <sup style={{color: 'blue', textDecoration: 'underline', cursor: 'pointer'}} onClick={() => setShowBreakdown(!showBreakdown)}> 
                      { !showBreakdown ? 'view breakdown' : 'hide breakdown' }
                    </sup>
                  </p>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <p><b>Profile Limit: </b> {plan.profile_limit ? `${plan.profile_limit} Profiles` : 'Unlimited Profiles'}</p>
                </div>
                <div className='col-md-6'>
                  <p><b>Created Profiles: </b> {total_profiles ? `${total_profiles} Profiles` : 'No Created Profiles'}</p>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <p><b>Start Date: </b> {start_date ? `${start_date}` : 'Not Revelant'}</p>
                </div>
                <div className='col-md-6'>
                  <p><b>End Date / Next Billing: </b> {end_date ? `${end_date}` : 'Not Relevant'}</p>
                </div>
              </div>
              {plan.next_billing && plan.next_billing.name &&
                <div className='row'>
                  <div className='col-md-6'>
                    <p><b>Pending Plan: </b> {plan.next_billing ? `${plan.next_billing.name}` : 'Not Revelant'}</p>
                  </div>
                  <div className='col-md-6'>
                    <p><b>Pending Plan Start Date: </b> {plan.next_billing ? `${plan.next_billing.start_date}` : 'Not Revelant'}</p>
                  </div>
                </div>
              }

              {plan.active && team.purchased_custom_domain &&
                <div className='row'>
                  <div className='col-md-6'>
                    <p><b>Add Ons: </b> Custom Domain</p>
                  </div>
                </div>
              }

              {plan.cost > 0 && !plan.active &&
                <div className='row'>
                  <div className='col-md-6'>
                    <p><b>Plan Status: </b> Canceled</p>
                  </div>

                  {team.purchased_custom_domain &&
                    <div className='col-md-6'>
                      <p><b>Add Ons: </b> Custom Domain</p>
                    </div>
                  }
                </div>
              }
            </div>
        </div>

        {user.user_type == 'manager' &&
          <div className='card'>
            <div className="card-header flex-header">
              <div>
                <h4 className="card-title">Payment Receipts</h4>
                <small>{receipts.length} Receipt Available</small>
              </div>

              <div className="btn-group">
                <button onClick={() => setShowItems(!showItems)}
                  name="button"
                  className="btn btn-primary"
                  type="button">
                  {!showItems && <>Show Receipts</>}
                  {showItems && <>Hide Receipts</>}
                </button>
              </div>
            </div>

            {showItems &&
              <div className="list-group list-group-flush">
              {receipts.length > 0 && receipts.map((receipt, index) => (
                <div key={receipt.id} className="list-group-item">
                  <div className="list-group-item-body">
                    <div className="list-group-item-body-main-invoices">
                      <div className="list-item-title-segment">
                          <span style={{fontWeight: 'bold'}}>Receipt ID: </span>{receipt.receipt_id}
                      </div>
                    <div className="list-item-title-segment d-none-mobile">
                        <span style={{fontWeight: 'bold'}}>Payment Amount: </span>${parseFloat(receipt.amount).toFixed(2)}
                    </div>
                    <div className="list-item-total d-none-mobile">
                        <span style={{fontWeight: 'bold'}}>Payment Date: </span> {receipt.payment_date}
                    </div>
                    </div>
                  </div>
                  <div className="list-group-item-actions d-none-mobile">
                    <a
                      href={`/team/plan/receipt/${receipt.id}`}
                      className="btn btn-sm btn-primary ml-2"
                    >
                      View Receipt
                    </a>
                  </div>
                </div>
              ))}
            </div>
            }
          </div>
        } 

        {openModal &&
          <AddOnPurchase close={() => setOpenModal(false)} handleSubmit={purchaseDomain} saving={saving} team={team} />
        }  

        {openPlansModal &&
        <PurchasePlan plan={plan} end_date={end_date} close={() => setOpenPlansModal(false)} team={team}/>
        }

        {openProfilesModal &&
          <AdditionalProfilesModal 
            plan={plan} 
            close={() => setOpenProfilesModal(false)} 
            handleSubmit={(value) => handleBuyProfiles(value)}
            saving={buyingProfiles}
            team={team}
          /> 
        }
    </div>
  )
}
